/**
 * Utilidades para comprobación y resolución de resultados de tareas (jobs).
 * Soporta tanto estados locales ("done", "running", "failed") como de backend
 * ("completed", "submitted", "polling", "failed", etc.).
 */

export function isJobCompleted(job) {
  if (!job) return false;
  return (
    job.status === "done" ||
    job.submissionState === "completed" ||
    job.submission_state === "completed"
  );
}

export function isJobRunning(job) {
  if (!job) return false;
  return (
    job.status === "running" ||
    job.status === "pending" ||
    job.submissionState === "submitted" ||
    job.submissionState === "polling" ||
    job.submission_state === "submitted" ||
    job.submission_state === "polling"
  );
}

export function isJobFailed(job) {
  if (!job) return false;
  return (
    job.status === "failed" ||
    job.submissionState === "failed" ||
    job.submission_state === "failed"
  );
}

export function getJobResultAssetIds(job) {
  if (!job) return [];
  if (Array.isArray(job.resultAssetIds) && job.resultAssetIds.length > 0) {
    return job.resultAssetIds;
  }
  if (Array.isArray(job.result_asset_ids) && job.result_asset_ids.length > 0) {
    return job.result_asset_ids;
  }
  if (job.resultAssetId) {
    return [job.resultAssetId];
  }
  if (job.asset_id) {
    return [job.asset_id];
  }
  return [];
}

export function getJobPrimaryAsset(job, assetById) {
  if (!job || !assetById) return null;
  const ids = getJobResultAssetIds(job);
  for (const id of ids) {
    if (assetById[id]) return assetById[id];
  }
  return null;
}
